import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { requestSelfEmploymentProfile } from '@/actions'
import { SelfEmploymentProfile } from '@/models'

import { getSelfEmploymentProfile } from '../profile'
import { useAppDispatch } from '../store'

export const useSelfEmploymentProfile = () => {
    const dispatch = useAppDispatch()
    const selfEmploymentProfile = useSelector(getSelfEmploymentProfile)
    const { shouldFetch } = selfEmploymentProfile

    useEffect(() => {
        if (!shouldFetch) return
        dispatch(requestSelfEmploymentProfile())
    }, [dispatch, shouldFetch])

    return { selfEmploymentProfile: selfEmploymentProfile as SelfEmploymentProfile }
}
